<template>
  <div class="imgView">
    <!-- 图片预览 -->
    <el-image-viewer
      v-show="imgViewShow"
      :zIndex="3000"
      :url-list="imgList"
      :on-close="closeImgView"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  name: 'ImageView',
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
    imgViewShow: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    // 引入element UI中预览组件
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  // mounted () {
  //   // 在dialog中点击预览，dialog会把预览的图片遮住
  //   this.$nextTick(() => {
  //     const elImageViewerWrapper = document.querySelector('.el-image-viewer__wrapper')
  //     console.log({ elImageViewerWrapper })
  //     // // 获取上一个元素
  //     const preEle = elImageViewerWrapper && elImageViewerWrapper.previousElementSibling;
  //     console.log(preEle)
  //     // // 上一个元素是否是Dialog
  //     // const isDialog = preEle && preEle.classList && preEle.classList.includes('el-dialog__wrapper')
  //     // isDialog && (elImageViewerWrapper.style.zIndex = 3000)
  //   })
  // },
  methods: {
    closeImgView() {
      this.$emit('closeImgView')
    },
  },
}
</script>

